export const chartColors = {
  charcoal: '#363A3A',
  deepAquamarine: '#115E67',
  lovelyPurple: '#7F2BED',
  azul: '#0555F0',
  infoYellow: '#F89603',
  culturedPearl: '#F3F4F4',
};

/** Mirrors theme.scss $red, $burntOrange, $orange, $tealBlue. */
export const severityChartColors = {
  critical: '#DC2626',
  high: '#D94906',
  medium: '#FFAD08',
  low: '#008C95',
};

export const maIroScoringColors = {
  opportunityGreen: '#4A9B8E',
  riskRed: '#DC2626',
  tooltipBackground: '#FFFFFF',
  tooltipBorder: '#DBDDDE',
  gridColor: '#8EA4A6',
  axisLineColor: '#9CA3AF',
  chartBorder: '#8EA4A6',
  opportunityBackground: 'rgba(74, 155, 142, 0.2)',
  riskBackground: 'rgba(229, 62, 62, 0.2)',
  labelTextWhite: '#FFFFFF',
  tooltipTitleColor: '#115E67',
  tooltipTextColor: '#363A3A',
  tooltipValueColor: '#115E67',
  strokeStyle: '#333333',
};

export const colorPalette = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
  '#F7DC6F', '#BB8FCE', '#85C1E9', '#F8C471', '#82E0AA',
  '#F1948A', '#AED6F1', '#A9DFBF', '#F9E79F', '#D7BDE2',
  '#A3E4D7', '#FAD7A0', '#D5A6BD', '#C39BD3', '#7FB3D3',
];

export const chartColorsArray = Object.values(chartColors);

/**
 * Series colours of the AI chat charts, in the order they are handed out: line 1 takes the first,
 * line 2 the second, and so on. Never cycled — a chart holds at most as many series as there are
 * entries. The order is what keeps neighbouring series apart under colour-blind vision, so it is
 * not to be reshuffled.
 *
 * Mirrors theme.scss $azul, $burntOrange, $lovelyPurple, $greenOnion, $teal, $electricFuchsia,
 * $red, $dodgerBlue.
 */
export const aiChatChartSeriesColors = [
  '#0555F0', '#D94906', '#7F2BED', '#7A9A01', '#00B7AD', '#CE01A8', '#DC2626', '#467AFF',
];

/** Ink of the AI chat charts: text, and the ring between two fills. Mirrors theme.scss $charcoal, $white. */
export const aiChatChartInkColors = {
  text: '#363A3A',
  surface: '#FFFFFF',
};
